import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class CompanyPriorityProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'priority/company'
}
